import React, { useEffect } from 'react'

/**
 * $BILL Tokenomics (List)
 *
 * Drop-in React component converted from the provided HTML.
 * You can override the defaults via props.
 */
export default function TokenomicsList({
  totalSupply = '937,648,991 $BILL',
  totalBurned = '62.4M $BILL',
  marketingDevWallet = 'FHg8gnrvbhuDkg67cSLgRVnFm1Za8uXhmz53c2dVUCPy',
  title = 'Token Overview',
  subtitle = 'A simple breakdown of $BILL economics',
}) {
  useEffect(() => {
    window.Jupiter.init({
      displayMode: 'integrated',
      integratedTargetId: 'target-container',
      formProps: {
        initialAmount: '2000000000',
        initialInputMint: 'So11111111111111111111111111111111111111112',
        initialOutputMint: '33LZGLLvtRDx3uAfJ1CcBSC7pNFqdiCBAvwPsVkBpump',
        fixedMint: '33LZGLLvtRDx3uAfJ1CcBSC7pNFqdiCBAvwPsVkBpump',
      },
    })
  }, [])
  return (
    <main id='tokenomics'>
      <style>{`
        :root{
          --bg:#0f1115;
          --card:#161b22;
          --text:#e8eef4;
          --muted:#a7b3bf;
          --border:#232a33;
          --accent:#3aa0ff;
        }
        *{box-sizing:border-box;margin:0;padding:0}
        body:has(#tokenomics){background:var(--bg);}
        #tokenomics{background:var(--bg);color:var(--text);line-height:1.6;padding:28px 16px}
        #tokenomics main{max-width:700px;margin:auto}
        #tokenomics header{text-align:center;margin-bottom:24px}
        #tokenomics .badge{display:inline-block;padding:4px 10px;border:1px solid var(--border);border-radius:999px;color:var(--accent);font-weight:600;margin-bottom:8px}
        #tokenomics h1{font-size:26px;font-weight:800;margin-bottom:4px}
        #tokenomics p.subtitle{color:var(--muted);font-size:14px;margin-bottom:16px}

        #tokenomics ul{list-style:none;display:flex;flex-direction:column;gap:14px;padding:0;margin:0}
        #tokenomics li{background:var(--card);border:1px solid var(--border);border-radius:12px;padding:16px}
        #tokenomics li h3{margin-bottom:6px;font-size:18px}
        #tokenomics li p{margin:0;color:var(--muted);font-size:14px}

        #tokenomics .bar{height:8px;border-radius:999px;background:#202733;overflow:hidden;margin-top:4px}
        #tokenomics .fill{height:100%;background:var(--accent)}
        #tokenomics .row{display:flex;justify-content:space-between;gap:8px}

        #tokenomics footer{margin-top:24px;font-size:12px;color:var(--muted);text-align:center}

        @media(min-width:600px){
          #tokenomics h1{font-size:30px}
          #tokenomics li h3{font-size:20px}
        }
      `}</style>

      <div style={{ maxWidth: 700, margin: '0 auto' }}>
        <header>
          <button
            onClick={() => {
              document
                .getElementById('buy-on-jupiter')
                .scrollIntoView({
                  behavior: 'smooth',
                  block: 'center',
                  inline: 'nearest',
                })
            }}
            className='jup-buy-btn'
            style={{
              margin: '0 0 40px 0',
              background:
                'linear-gradient(135deg, #C2FF3E, #7FFFA0, #45E2D3, #3BC6FF)',
              color: '#0D0F1A',
              padding: '15px 30px',
              border: 'none',
              borderRadius: '12px',
              fontSize: '16px',
              fontWeight: 600,
              cursor: 'pointer',
              boxShadow: '0 4px 10px rgba(0,0,0,0.25)',
              transition: 'transform 0.2s ease',
            }}
          >
            Buy $BILL
          </button>
          <h1>{title}</h1>
          <p className='subtitle'>{subtitle}</p>
          <img
            src='/logo.jpg'
            alt='logo'
            width='150px'
            style={{ borderRadius: '10px' }}
          />
        </header>
        <ul>
          <li>
            <h3>CA</h3>
            <p>
              <strong style={{ wordBreak: 'break-all' }}>
                33LZGLLvtRDx3uAfJ1CcBSC7pNFqdiCBAvwPsVkBpump
              </strong>
            </p>
          </li>
          <li>
            <h3>Total Supply</h3>
            <p>
              <strong>{totalSupply}</strong>
            </p>
          </li>

          <li>
            <h3>Total Burned</h3>
            <p>{totalBurned}</p>
          </li>
          <li>
            <h3>Marketing Wallet</h3>
            <p style={{ wordBreak: 'break-all' }}>{marketingDevWallet}</p>
          </li>
        </ul>
      </div>
      <div
        id='buy-on-jupiter'
        style={{
          margin: '20px 0 0 0',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <h1
          style={{
            margin: '30px 0 10px 0',
          }}
        >
          Buy on Jupiter
        </h1>
        <div
          id='target-container'
          style={{ width: '320px', height: '550px' }}
        ></div>
      </div>
    </main>
  )
}
